export const BASE_URL = 'http://localhost:5001'
export const USERS_URL = '/auth'
